
import { reportDialogService } from '../_services'
export const reportDialog = {

  namespaced: true,

  state: {
    allDialogs: [],
    selectedDialog: null
  },

  mutations: {
    setDialogs(state, dialogs) {
      dialogs.map(el => {
        el.messages.sort( (a, b) => new Date(a.createDate) - new Date(b.createDate))
      })
      state.allDialogs = dialogs
    },

    setSelectedDialog(state, dialog) {
      state.selectedDialog = dialog
    },

    setReadToMessage(state, msgId) {
      state.selectedDialog.message.find(el => el.id == msgId).read = true
    },

    addNewComment(state, message) {
      console.log(state.allDialogs, message.dialogId);
      
      let dialog = state.allDialogs.find(el => el.id == message.dialogId)
      
      if(dialog) {
        dialog.messages.push(message.message)
      }
    }
  },

  actions: {
    getAllDialogs({ commit }, reportUuid) {
      return reportDialogService.getAll(reportUuid).then(data => {
        commit('setDialogs', data)
      })
    }
  },

 
}